import React from "react";
import { FileText } from "lucide-react";

/**
 * EmptyInvoices
 *
 * Shown when there are no invoices available
 */
export default function EmptyInvoices() {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border bg-white p-10 text-center">
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
        <FileText className="h-6 w-6 text-gray-500" />
      </div>

      <h3 className="text-lg font-medium text-gray-900">
        No invoices yet
      </h3>

      <p className="mt-2 max-w-sm text-sm text-gray-500">
        Invoices will appear here once billing is enabled or a payment
        is recorded for your company.
      </p>
    </div>
  );
}